import React from "react";
import { createPortal } from "react-dom";
import { X, Bot, Sparkles } from "lucide-react";

const VoiceBotModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative w-[92%] max-w-md rounded-3xl bg-white shadow-2xl overflow-hidden">

        {/* Header */}
        <div className="bg-[#FED547] px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-black flex items-center justify-center">
              <Bot className="text-[#FED547]" size={26} />
            </div>

            <div>
              <h2 className="text-xl font-bold text-black">
                AI HR Assistant
              </h2>
              <p className="text-sm text-gray-800">
                Kadtech HR Solutions
              </p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="hover:rotate-90 transition"
          >
            <X size={22} />
          </button>
        </div>

        {/* Body */}
        <div className="p-8 text-center">

          <div className="w-24 h-24 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-6 animate-pulse">
            <Bot size={52} className="text-[#FED547]" />
          </div>

          <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-4 py-2 rounded-full text-sm font-semibold mb-5">
            <Sparkles size={16} />
            Coming Soon
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            AI Voice Assistant
          </h3>

          <p className="text-gray-600 leading-7">
            We're building an intelligent AI HR Assistant to help you with
            recruitment, hiring, job opportunities, and career guidance.
          </p>

          <div className="mt-6 rounded-xl bg-gray-100 p-4 text-sm text-gray-700">
            🚀 This feature will be available very soon.
            <br />
            Stay tuned for an amazing AI-powered experience!
          </div>

          <button
            onClick={onClose}
            className="mt-8 w-full h-12 rounded-xl bg-[#FED547] hover:bg-black hover:text-white font-semibold transition"
          >
            Got It
          </button>

        </div>
      </div>
    </div>,
    document.body
  );
};

export default VoiceBotModal;
